import React from 'react';
import { Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { RootState } from '../../../../../store';
type TagData = {
  tags: string;
  tag_short_name: string;
  tag_expiration_time: string;
};
interface TagsFomatterProps {
  id: string;
  data: TagData;
}
const TagsFomatter = ({ id, data }: TagsFomatterProps) => {
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const displayExpiration = !selectedTenancy?.features?.tags?.hideExpiration;

  const tags = data.tags.split('~');
  const tagShortNames = data.tag_short_name.split('~');
  // deduplicate the tagShortNames
  const uniqueTagShortNames = Array.from(new Set(tagShortNames));
  const tagExpirationTime = data.tag_expiration_time.split('~');
  const tagLimit = 2;

  const getExpiration = (i: number) => {
    if (!displayExpiration) {
      return '';
    }
    const expiration = ` (${tagExpirationTime[i]})`;
    return expiration;
  };
  const combinedTagsAndExpirations = uniqueTagShortNames
    .slice(tagLimit)
    .map((tag, i) => `${tag}${getExpiration(tagLimit + i)}`);

  if (!data) {
    return null;
  }

  return (
    <div key={id}>
      {uniqueTagShortNames.slice(0, tagLimit).map((tagShortName, i) => (
        <Badge
          className={'tagShortName'}
          style={{ cursor: 'default' }}
          data-tip={`${tags[i]}${getExpiration(i)}`}
          key={i}
        >
          {tagShortName}
        </Badge>
      ))}
      {tags.length > tagLimit && (
        <Badge
          className={'tagNumber'}
          data-tip={combinedTagsAndExpirations.join(', ')}
          style={{ cursor: 'default' }}
        >
          +{tags.length - tagLimit}
        </Badge>
      )}
      <ReactTooltip />
    </div>
  );
};

export default TagsFomatter;
